export default __webpack_public_path__ + "static/media/illustration-empty-state.4669a94f.png";